module.exports = __webpack_public_path__ + "static/img/home_icon_ryzz.d805250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_icon_ryzz.png
// module id = Z61a
// module chunks = 11